import Form from 'Components/Forms/FormGenerator';
import FormViewer from 'Components/FormViewer';
import { actions } from 'ducks/automationConditions';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { serializeForm } from 'utils/forms/utils';
import validators from 'utils/forms/validators';

const ManageConditions = props => {
    const { measurementId, closeDrawer } = props;
    const dispatch = useDispatch();

    const automationConditions = useSelector(state => state.automationConditions.models);
    const measurement = useSelector(state => state.measurements.models[measurementId]);
    const submitting = useSelector(state => state.automationConditions.submitting);

    const measurementAutomationCondition = Object.values(automationConditions).find(automationCondition => automationCondition.measurement_id === measurement.id);

    const { create, remove } = {
        create: (values, closeDrawer) => dispatch(actions.create(values, closeDrawer)),
        remove: (id, closeDrawer) => dispatch(actions.remove(id, closeDrawer))
    };

    if (measurementAutomationCondition) {
        const formSchema = [
            {
                disabled: true,
                type: 'text',
                label: 'Formula',
                name: 'formula',
                placeholder: 'Note: the only valid formula at the moment is in the format of "UUID == on|off" (no extra spaces), where UUID is the UUID of one of the available WiseInputs of type digital.'
            },
            {
                disabled: true,
                type: 'text',
                label: 'Priority',
                name: 'priority'
            },
            {
                disabled: true,
                type: 'text',
                label: 'Output',
                name: 'output'
            }
        ];

        const onSubmit = () => {
            remove(measurementAutomationCondition.id, closeDrawer);
        };

        return (
            <FormViewer label="Remove Automation Condition">
                <Form
                    buttonLabel="Remove"
                    formInitialValues={measurementAutomationCondition}
                    formSchema={formSchema}
                    isSubmitting={submitting}
                    onSubmit={onSubmit}
                />
            </FormViewer>
        );
    } else {
        const formSchema = [
            {
                type: 'text',
                label: 'Automation Condition\x2a',
                name: 'formula',
                placeholder: 'Note: the only valid formula at the moment is in the format of "UUID == on|off" (no extra spaces), where UUID is the UUID of one of the available WiseInputs of type digital.',
                validate: [validators.required]
            },
            {
                formData: [1, 2, 3, 4].map(v => ({ id: v, name: v })),
                label: 'Priority\x2a',
                name: 'priority',
                type: 'select',
                validate: [validators.required]
            },
            {
                formData: ['off', 'on'].map(v => ({ id: v, name: v })),
                label: 'Output\x2a',
                name: 'output',
                type: 'select',
                validate: [validators.required]
            }
        ];

        const onSubmit = formValues => {
            const values = serializeForm(formValues, formSchema);
            values['measurement_id'] = measurement.id;

            create(values, closeDrawer);
        };

        return (
            <FormViewer label="Create Automation Condition">
                <Form
                    formSchema={formSchema}
                    isSubmitting={submitting}
                    onSubmit={onSubmit}
                />
            </FormViewer>
        );
    }
};

export default ManageConditions;
